function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.143 16.6667H31.8409C32.1951 16.6667 32.4764 16.9583 32.4659 17.3125L31.6847 37.7292C31.6743 38.0625 31.393 38.3333 31.0597 38.3333H28.9243C28.5909 38.3333 28.3097 38.0729 28.2993 37.7292L27.518 17.3125C27.5076 16.9583 27.7889 16.6667 28.143 16.6667ZM29.9972 40.4167C28.3826 40.4167 27.0805 41.7188 27.0805 43.3333C27.0805 44.9479 28.3826 46.25 29.9972 46.25C31.6118 46.25 32.9139 44.9479 32.9139 43.3333C32.9139 41.7188 31.6118 40.4167 29.9972 40.4167ZM59.3201 45.8333L34.3305 2.5C32.4139 -0.833333 27.5909 -0.833333 25.6639 2.5L0.674281 45.8333C-1.24239 49.1563 1.15345 53.3333 5.00761 53.3333H54.9972C58.8305 53.3333 61.2472 49.1667 59.3201 45.8333ZM54.9972 50H4.9972C3.71595 50 2.91386 48.6146 3.54928 47.5L28.5493 4.16667C29.1847 3.0625 30.7993 3.05208 31.4347 4.16667L56.4347 47.5C57.0805 48.6042 56.2784 50 54.9972 50Z",
  fill: "white"
});

function SvgWarningOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutline);
export default __webpack_public_path__ + "static/media/warning_outline.0d5d83ac.svg";
export { ForwardRef as ReactComponent };